<!-- Account details screen -->
<div class="row justify-content-center m-0">
    <div class="col-lg-10">

        <app-quick-guides #quickguides *ngIf="permissions?.can?.show_intro_tour?.site_settings && (uiManager.toggleQuickGuide$ | async)?.screen == 'account' && (uiManager.toggleQuickGuide$ | async)?.show" [context]="this" guidesMode="account"></app-quick-guides>
      
        <!-- Account details heading -->
        <h2 translate class="mt-3">NAV.MENU_ACCOUNT_ADMIN</h2>
  
        <mat-card *ngIf="fourD.activeTeam" class="mt-3 mb-4">
            <mat-card-header>
            </mat-card-header>
            <mat-card-content>

                <div class="row">
                    <div class="col-3 text-center">

                        <!-- Change account logo -->
                        <img class="full-width" vlink="image.png" [cache]="false" [model]="fourD.activeTeam" [alt]="fourD.activeTeam.name">
                         <label for="image-change" id="account-image">
                            <a mat-raised-button color="primary" >{{'PROFILE.CHANGE_IMAGE' | translate }}</a>
                        </label>

                        <!-- Upload image -->
                        <input id="image-change" type="file" (change)="uploadFile($event)" placeholder=" {{'PROFILE.UPLOAD.FILE' | translate }}" accept=".png,.jpg,.jpeg" hidden="true">

                    </div>
                    
                    <div class="col">     
        
                        <!-- Quick Guides icon-->
                        <button mat-icon-button matTooltip="{{ 'NAV.QUICK_GUIDES' | translate }}" class="fdm-linked float-right" (click)="uiManager.toggleQuickGuidePopup('account', true)">
                        <fa-icon icon="question-circle"></fa-icon>
                        </button>  

                        <!-- Account name -->
                        <div qmap-question [qMap]="{id:'name',title:'SETTINGS.ACCOUNT_NAME' | translate}" [model]="fourD.activeTeam" id="account-name"></div>
                        
                        <!-- Account description -->
                        <div qmap-question [qMap]="{id:'desc',title:'SETTINGS.ACCOUNT_DESC' | translate, type:'text'}" [model]="fourD.activeTeam" id="account-desc"></div>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions class="text-right">

                <!-- Save button-->
                <button mat-button (click)="saveCurrentAccount()" id="account-save" color="primary">{{ 'GENERIC.SAVE' | translate }}</button>
               
                <!--<button mat-button (click)="deleteCurrentAccount()" color="warn">{{ 'GENERIC.DELETE' | translate }}</button>-->
            </mat-card-actions>
        </mat-card>

    </div>

</div>

<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>